export class Customer {
    public customerNumber: number;
    public name: string;
    public dbaName: string;
    public statusFlag: string;
    public contact: string;
    public address1: string;
    public address2: string;
    public city: string;
    public state: string;
    public postalCode: string;
    public country: string;
    public phone: string;
    public fax: string;
    public email: string;
    public payLocationCount: number;
    public specialFlag: string;
    public acctMgr: string;

    public validations;
}
